import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { ContactTypeCards } from "./contact-type-cards";
import { SmsPanel } from "./panels/sms-panel";
import { VoiceCallPanel } from "./panels/voice-call-panel";
import { InSystemPanel } from "./panels/in-system-panel";
import { PreRecordedVoicePanel } from "./panels/pre-recorded-voice-panel";
import { SafeCallPanel } from "./panels/safe-call-panel";
import type { ContactType, Patient } from "./types";

interface Props {
  showModal: boolean;
  setShowModal: (data: boolean) => void;
  selectedPatient: Patient | null;
}

export default function ContactPatient({
  setShowModal,
  showModal,
  selectedPatient,
}: Props) {
  const { t } = useTranslation();
  const [contactType, setContactType] = useState<ContactType>("sms");

  if (!selectedPatient) return null;

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="md:min-w-xl lg:min-w-4xl max-h-[calc(100dvh-2rem)] grid-rows-[auto_1fr]">
        <DialogHeader>
          <DialogTitle>
            {t("select_contact_type_for") + ` "${selectedPatient.name}"`}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 min-h-0 overflow-hidden">
          <ContactTypeCards
            selected={contactType}
            onSelect={setContactType}
            hiddenOptions={
              selectedPatient.name === "تست ویزیت انلاین" ? ["voice_call"] : []
            }
          />
          <div key={contactType} className="flex-1 min-h-0 flex flex-col">
            {contactType === "sms" && (
              <SmsPanel
                patient={selectedPatient}
                onClose={() => setShowModal(false)}
              />
            )}
            {contactType === "voice_call" && (
              <VoiceCallPanel
                patient={selectedPatient}
                onClose={() => setShowModal(false)}
              />
            )}
            {contactType === "inSystem" && (
              <InSystemPanel
                patient={selectedPatient}
                onClose={() => setShowModal(false)}
              />
            )}
            {contactType === "preRecordedVoice" && (
              <PreRecordedVoicePanel
                patient={selectedPatient}
                onClose={() => setShowModal(false)}
              />
            )}
            {contactType === "safe_call" && (
              <SafeCallPanel
                patient={selectedPatient}
                onClose={() => setShowModal(false)}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
